export const ACTIONS_LICENSE = {
  INVALIDATE: 'LICENSES_INVALIDATE',
  RECEIVE: 'LICENSES_RECEIVE',
  DELETE: 'LICENSE_DELETE',
  UPDATE: 'LICENSE_UPDATE',
};

const licenseConstants = {};

export default licenseConstants;
